
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { camelToDash } from '../../dom/utils/camel-to-dash.mjs.js';
import { renderHTML } from '../../html/utils/render.mjs.js';
import { camelCaseAttributes } from './camel-case-attrs.mjs.js';

function renderSVG(element, renderState, _styleProp, projection) {
    renderHTML(element, renderState, undefined, projection);
    for (var key in renderState.attrs) {
        element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
    }
}

export { renderSVG };
//# sourceMappingURL=render.mjs.js.map
